import { requireRouteAudience } from '@services/router/routeAccess'
import {
  createFileRoute,
  Outlet,
} from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/calendar')({
    component: Outlet,
    beforeLoad: requireRouteAudience(['staff', 'student', 'parent']),
    staticData: {
        crumb: {
            label: 'Calendar',
        }
    }
})